import { QUESTION_INSIGHTS_API } from "admin/types/constants/questionInsights";
import type { ClassificationSummary } from "admin/types/interfaces/questionInsights";
import { useFetcher } from "~/hooks/useFetcher";

interface UseQuestionInsightsParams {
  // Narrow every figure to these originating apps (each must be an app the
  // dashboard covers). Omit to aggregate all covered apps.
  appIds?: string[];
}

function buildUrl({ appIds }: UseQuestionInsightsParams): string {
  const params = new URLSearchParams();
  appIds?.forEach((id) => params.append("app_ids", id));
  const queryString = params.toString();
  return `${QUESTION_INSIGHTS_API}/summary${queryString ? `?${queryString}` : ""}`;
}

const useQuestionInsights = ({ appIds }: UseQuestionInsightsParams = {}) => {
  const url = buildUrl({ appIds });

  const { data, error, isLoading } = useFetcher<ClassificationSummary>(url, {
    shouldCamelize: true,
    keepPreviousData: true,
  });

  return {
    summary: data,
    error,
    isLoading,
    key: url, // resolved SWR key so callers can revalidate
  };
};

export default useQuestionInsights;
